module.exports = __webpack_public_path__ + "static/img/YB-25V.ec4fb91b.png";